import request from '@/utils/request';

//获取所有得容器模板组件得名称和标识
export function getContainerNameAndMark(data) {
  return request.post('admin/container-template/name-mark', data);
}
//获取容器模板组件
export function getContainerList(data) {
  return request.post('admin/container-template/list', data);
}

//获取容器模板组件详情
export function getContainerDetail(data) {
  return request.post('admin/container-template/detail', data);
}

//容器模板组件状态修改
export function changeContainerStatus(data) {
  return request.post('admin/container-template/status', data);
}

//获取文件模板数据源
export function getTemplateDataSources(data) {
  return request.post('admin/container-template/data-source', data);
}

//获取函数资源
export function getFunctionResource(data) {
  return request.post('admin/container-template/function-resource', data);
}

//新增容器模板
export function addContainerTemplate(data) {
  return request.post('admin/container-template/store', data);
}

//获取容器模板组件详情
export function getContainerTemplateDetail(data) {
  return request.post('admin/container-template/detail', data);
}

//编辑容器模板
export function editContainerTemplate(data) {
  return request.post('admin/container-template/edit', data);
}